import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { isNil } from '@grandvisionhq/utils';
import { useAddToCart } from '../../../hooks/use-add-to-cart.js';
import { useSanitization } from '../../../hooks/use-sanitization.js';
import { AddToCart } from '../components/AddToCart.js';
import { ConfirmationModalContainer } from './ConfirmationModalContainer.js';
import { useCart } from '../../../context/Cart/context.js';

var AddToCartContainer = (_param)=>{
    var { lineItemDrafts , onSuccess  } = _param, buttonProps = swcHelpers.objectWithoutProperties(_param, [
        "lineItemDrafts",
        "onSuccess"
    ]);
    const [addToCart, { loading  }] = useAddToCart();
    const { cart  } = useCart();
    const [{ isModalOpen , sanitizationPayloads , validation  }, { onSolvableValidationError , pushRemoveLineItemDataLayerEvent , reset  }, ] = useSanitization();
    const onValidationError = React.useCallback((validationCodes)=>{
        validationCodes.forEach((code)=>toast.failed(`cart.${code}`)
        );
    }, []);
    const onError = React.useCallback((errorCode)=>{
        toast.failed(`cart.${errorCode}`);
    }, []);
    const handleSuccess = React.useCallback((addedLineItems)=>{
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(addedLineItems);
        reset();
    }, [
        onSuccess,
        reset
    ]);
    const handleOnClick = React.useCallback(()=>{
        addToCart(lineItemDrafts, handleSuccess, onValidationError, onError, onSolvableValidationError, sanitizationPayloads, pushRemoveLineItemDataLayerEvent);
    }, [
        addToCart,
        lineItemDrafts,
        handleSuccess,
        onError,
        onValidationError,
        onSolvableValidationError,
        sanitizationPayloads, 
    ]);
    if (!lineItemDrafts.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, !isNil(validation) && /*#__PURE__*/ React.createElement(ConfirmationModalContainer, {
        lineItems: cart === null || cart === void 0 ? void 0 : cart.lineItems,
        handleOnAction: handleOnClick,
        handleOnCancel: reset,
        isLoading: loading,
        isOpen: isModalOpen,
        onModalClose: reset,
        validation: validation
    }), /*#__PURE__*/ React.createElement(AddToCart, swcHelpers.extends({
        onClick: handleOnClick,
        disabled: loading || buttonProps.disabled
    }, buttonProps)));
};

export { AddToCartContainer };
//# sourceMappingURL=AddToCartContainer.js.map
